import { connectFela } from '../../dependencies';
import ReportControl from './ReportControl';
import * as styles from './ReportControl.styles';

export default connectFela(styles)(ReportControl);
